<template>
  <v-row
    no-gutters
    class="fill-height"
  >
    <v-dialog
      v-model="dialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            icon
            @click="dialog = false"
          />
        </v-card-actions>
        <v-card-text class="modal-style">
          <h3>{{ $t("components.OperatorsLogs.question3.title") }}</h3>
          <p>{{ $t("components.OperatorsLogs.question3.description") }}</p>
          <h3>{{ $t("components.OperatorsLogs.question4.title") }}</h3>
          <p>{{ $t("components.OperatorsLogs.question4.description") }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ColumnChart
      :request-status="requestStatus"
      :categories="categories"
      :series="series"
      :title="title"
      :item-id="itemId"
      :card-options="cardOptions"
      :show-granularity="false"
      :show-description="true"
      :open-dialog="openDialog"
      v-bind="$attrs"
      @reload="getData"
    />
  </v-row>
</template>

<script>
import ColumnChart from '@/components/cards/models/ColumnChart';
import channelModel from '@/mixins/channel-model';
import cardsModel from '@/mixins/cards-model';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/event-bus';
import { OPERATION } from '@/services/charts-service';
import statusModel from '@/mixins/status-model';
import { DsButton } from '@ds/components';

export default {
  name: 'ChangeStatus',
  components: {
    ColumnChart,
    DsButton,
  },
  mixins: [
    channelModel,
    cardsModel,
    statusModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
    ownerPosts: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: {},
      classifiedPercentage: 0,
      categories: [],
      dialog: false,
      closeLabel: this.$t('components.OperatorsLogs.closeLabel'),
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
    ]),
    ...mapGetters('filter', [
      'getStartDateInMilliseconds',
      'getEndDateInMilliseconds',
      'getEndDate',
    ]),
    series() {
      const data = {};
      let index = 0;
      if (!this.rawSeries[0]) {
        return [];
      }
      this.rawSeries.forEach(serie => {
        serie.status.forEach(status => {
          if (!data[status.name]) {
            data[status.name] = [];
            for (let i = 0; i < index; i++) {
              data[status.name].push(0);
            }
          }
          data[status.name].push(status.total);
          Object.entries(data).forEach(([key, value]) => {
            if (value.length < index) {
              data[key].push(0);
            }
          });
        });
        index++;
      });
      return Object.keys(data).map(status => (
        {
          name: this.getStatusColorAndName(status).name,
          data: data[status],
          color: this.getStatusColorAndName(status).color,
        }
      ));
    },
    cardOptions() {
      return {
        legend: {
          enabled: true,
        },
        tooltip: {
          shared: true,
        },
        lang: {
          exportData: {
            categoryHeader: this.$t('components.OperatorsLogs.username'),
          },
        },
        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          labels: {
            enabled: true,
            formatter() {
              return `${this.value.toLocaleString('pt-BR')}`;
            },
          },
        },
      };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getOperatorsLogsService',
    ]),
    openDialog() {
      this.dialog = true;
    },
    async getData(options) {
      const unallowedEmployees = ['Alexsandro Oliveira', 'Beatriz Santos', 'Carolina Lopez', 'Stilingue Serviço Mudança de Status'];
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getOperatorsLogsService({
        itemId: this.itemId,
        servicePath: 'getStatusChange',
        serviceParams: {
          starting_at: this.getStartDateInMilliseconds,
          ending_at: this.getEndDateInMilliseconds,
          status: 'Fechado, Respondido, Ignorado',
          usernames: this.selectedOperators ? this.selectedOperators.value.join('", "') : null,
        },
      })
        .then(response => {
          response.annotationsStatus.sort(function (a, b) {
            const aSum = a.totalStatus;
            const bSum = b.totalStatus;
            return aSum > bSum ? -1 : 0;
          });
          const filteredResponse = response.annotationsStatus.filter(annotation => !unallowedEmployees.includes(annotation.username));
          this.rawSeries = filteredResponse.map(serie => {
            this.categories.push(serie.username);
            delete serie.username;
            delete serie.totalStatus;
            return serie;
          });
          this.requestStatus = 'success';
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .close-button {
    display: flex;
    flex: end;
    justify-content: flex-end;
  }

  .modal-style {
    * {
      color: var(--ds-color-snow) !important;
    }

    h3 {
      font-weight: var(--ds-font-weight-bold);
    }
  }
</style>
